import { useEffect, useState } from "react";
import { fmtClock } from "../lib/relayGame";

/** Coarse human countdown: whole hours → minutes → seconds (23hr, 42min, 30s). */
function fmtCoarse(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s >= 3600) return `${Math.floor(s / 3600)}hr`;
  if (s >= 60) return `${Math.floor(s / 60)}min`;
  return `${s}s`;
}

/**
 * Live countdown until `endsAt` (ms epoch). Calls onDone once when it hits
 * zero. Default format is mm:ss (game clocks); `coarse` renders a single
 * human unit for long deadlines (the paywall's 24h window).
 */
export default function Countdown({ endsAt, onDone, className, coarse }: { endsAt: number; onDone?: () => void; className?: string; coarse?: boolean }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    if (now >= endsAt) onDone?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [now >= endsAt]);
  return <span className={className}>{coarse ? fmtCoarse(endsAt - now) : fmtClock(endsAt - now)}</span>;
}

/** Re-render children on a steady tick (for phase machines derived from clock). */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
